import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { forkJoin, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Environment } from 'src/environments/environment';

import { UrlHelpers } from './urlHelpers';
import { PlanetProofReport } from '../models';
import { isPlanetProofCalculationComplete } from '../util/planet-proof-report';

@Injectable({
  providedIn: 'root',
})
export class PlanetProofService {
  protected http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  protected baseUrl = this.env.API_BASE_URL + '/service/planet-proof/secure/';

  getPlanetProofReport(cropYear: number, cropFieldIds: number[]): Observable<PlanetProofReport> {
    if (this.env.USE_ARABLE_SERVICE_PLANET_PROOF_REPORT) {
      const url = `${this.env.APIM_BASE_URL}/arable-service/environmental/planetproof/reports/${cropYear}`;
      return this.http.get<PlanetProofReport>(
        `${url}?${UrlHelpers.getParamString('cropFieldIds', cropFieldIds)}`,
      ).pipe(map((report) => {
        let calculationStatus = report.calculationStatus;
        if (calculationStatus !== 'notCalculated') {
          calculationStatus = isPlanetProofCalculationComplete(report, true) ? 'complete' : 'incomplete';
        }
        return { ...report, calculationStatus };
      }));
    }
    const reportUrl = `${this.baseUrl}planetproofreport/${cropYear}`;
    return forkJoin({
      selected: this.http.get<PlanetProofReport>(
        `${reportUrl}/cropfields?${UrlHelpers.getParamString('cropFieldIds', cropFieldIds)}`,
      ),
      company: this.http.get<PlanetProofReport>(reportUrl),
    }).pipe(
      map(({ selected, company }) => ({
        ...selected,
        totalHectares: company.totalHectares,
        totalGlyphosateUsage: company.totalGlyphosateUsage,
        glyphosateMalusPoints: company.glyphosateMalusPoints,
      })),
    );
  }
}
